import { NavMenu, NavMenuGroup, NavMenuItem } from "./NavMenu";

class DefaultNavMenu extends NavMenu {
  constructor() {
    super({
      id: 'default-nav-menu',
      classes: 'nav-menu--default light_mode',
      items: (() => {
        if (navbarConfigs.isGuest) {
          return [
            DefaultNavMenu.loginItem,
            DefaultNavMenu.signUpItem,
            DefaultNavMenu.helpAboutGroup,
          ]
        }

        if (navbarConfigs.isAdmin) {
          return [
            DefaultNavMenu.myProfileGroup,
            DefaultNavMenu.adminMenuGroup,
            DefaultNavMenu.helpAboutGroup,
            DefaultNavMenu.logoutItem,
          ]
        }

        return [
          DefaultNavMenu.myProfileGroup,
          DefaultNavMenu.helpAboutGroup,
          DefaultNavMenu.logoutItem,
        ]
      })(),
    })
  }

  static get logoutItem() {
    return new NavMenuItem({
      label: 'Logout',
      labelLangKey: 'user-profile-logout',
      url: '/logout',
      attributes: {
        'data-method': 'post'
      },
      onClick: () => {
        sessionStorage.removeItem('customEmailTracked');
      }
    })
  }

  static get loginItem() {
    return new NavMenuItem({
      label: 'Log in',
      labelLangKey: 'login-text',
      onClick: () => {
        openLoginModal()
      }
    })
  }

  static get signUpItem() {
    return new NavMenuItem({
      label: 'Register',
      labelLangKey: 'register-text',
      onClick: () => {
        openRegisterModal()
      }
    })
  }

  static get adminMenuGroup() {
    return new NavMenuGroup({
      name: 'administration',
      items: [
        new NavMenuItem({
          label: 'Administration',
          labelLangKey: 'administration-text',
          submenu: new NavMenu({
            items: [
              new NavMenuItem({
                label: 'Spaces Management',
                labelLangKey: 'admin-spaces-management',
                url: '/admin/spaces',
              }),
              new NavMenuItem({
                label: 'Users Management',
                labelLangKey: 'admin-users-management',
                url: '/admin/users',
              }),
              new NavMenuItem({
                label: 'Roles Management',
                labelLangKey: 'admin-roles-management',
                url: '/admin/roles',
              }),
              new NavMenuItem({
                label: 'Plans Management',
                labelLangKey: 'admin-plans-management',
                url: '/admin/plans',
              }),
              new NavMenuItem({
                label: 'Self check',
                labelLangKey: 'admin-self-check',
                url: '/admin/self-check',
              }),
              new NavMenuItem({
                label: 'Portal settings',
                labelLangKey: 'admin-portal-settings',
                url: '/admin/portal-settings',
              }),
              new NavMenuItem({
                label: 'VAPI agents',
                labelLangKey: 'admin-vapi-agents',
                url: '/admin/vapi-agents',
              }),
              new NavMenuItem({
                label: 'VAPI conversations',
                labelLangKey: 'admin-vapi-conversations',
                url: '/admin/vapi-call-reports',
              }),
            ],
          }),
        }),
      ]
    })
  }

  static get myProfileGroup() {
    return new NavMenuGroup({
      name: 'my-profile',
      items: [
        new NavMenuItem({
          label: 'My Profile',
          labelLangKey: 'my-profile-text',
          submenu: new NavMenu({
            items: [
              new NavMenuItem({
                label: 'My Profile',
                labelLangKey: 'my-profile-text',
                url: '/myprofile',
              }),
              new NavMenuItem({
                label: 'Spaces',
                labelLangKey: 'spaces-text',
                url: '/myprofile/spaces',
              }),
              new NavMenuItem({
                label: 'Tours',
                labelLangKey: 'tours-text',
                url: '/myprofile/tours',
              }),
              new NavMenuItem({
                label: 'Notifications',
                labelLangKey: 'notifications-text',
                url: '/myprofile/notifications',
              }),
              new NavMenuItem({
                label: 'Subscription & Billing',
                labelLangKey: 'subscription-billing-text',
                url: '/myprofile/subscriptions',
              }),
            ],
          }),
        }),
      ]
    })
  }

  static get helpCenterItem() {
    return new NavMenuItem({
      label: 'Help Center',
      labelLangKey: 'help-center-text',
      id: 'help_center',
      classes: 'bagless-help-center-trigger',
      onClick: (e) => {
        e?.stopPropagation?.();
        e?.preventDefault?.();
        if (typeof window.openBaglessHelpCenter === 'function') {
          window.openBaglessHelpCenter(e);
        }
      }
    })
  }

  static get aboutItem() {
    return new NavMenuItem({
      label: 'About',
      labelLangKey: 'about-bagless',
      onClick: () => {
        if (typeof window.openVersionModal === 'function') {
          window.openVersionModal();
          return;
        }
        $("#version-modal").addClass("is-active");
      }
    })
  }

  static get helpAboutGroup() {
    return new NavMenuGroup({
      name: 'help',
      items: [
        DefaultNavMenu.helpCenterItem,
        DefaultNavMenu.aboutItem,
      ]
    })
  }
}

export default DefaultNavMenu;
